import { render, staticRenderFns } from "./p4s3Integrations.vue?vue&type=template&id=3a62c164"
import script from "./p4s3Integrations.vue?vue&type=script&lang=js"
export * from "./p4s3Integrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports